import http from '../request/http'

export const newsApi = {
  list: params => {
      return http.get('/manage/news/list', params)
  },
    info: id => {
      return http.get(`/manage/news/info/${id}`)
    }
};
